import { FieldTypes } from '../filter';

export const FilterForm = {
  id: { type: FieldTypes.textInput, name: 'id',key:'id' },
  iban: { type:FieldTypes.textInput,  name: 'iban',key:'iban'},
  dateFrom: { type: FieldTypes.dateTimeInput,  name: 'dateFrom',key:'dateFrom'},
  dateTo: { type: FieldTypes.dateTimeInput, name: 'dateTo',key:'dateTo'},
}